import React, { createContext, useContext } from 'react';
import { useJudgeStationSettings as useJudgeStationSettingsHook } from '../hooks/useJudgeStationSettings';

// Create context
const JudgeStationSettingsContext = createContext();

// Hook to use the context
export const useJudgeStationSettings = () => {
  const context = useContext(JudgeStationSettingsContext);
  if (!context) {
    throw new Error('useJudgeStationSettings must be used within a JudgeStationSettingsProvider');
  }
  return context;
};

// Provider component
export const JudgeStationSettingsProvider = ({ children }) => {
  // Use the hook that connects to AWS
  const hookData = useJudgeStationSettingsHook();

  const value = {
    // Pass through all hook data
    ...hookData,
    // Maintain backward compatibility with old property names
    settings: hookData.settings,
    loadSettings: hookData.fetchJudgeStationSettings,
    updateSettings: hookData.updateJudgeStationSettings,
    resetToDefaults: hookData.resetSettings,
  };

  return (
    <JudgeStationSettingsContext.Provider value={value}>
      {children}
    </JudgeStationSettingsContext.Provider>
  );
};

export default JudgeStationSettingsContext;
